import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useNfuData from "../../hooks/punto_generacion/useNfuReportadosVSEntregados";
import { getChartOptions } from "../../utils/punto_generacion/chart_nfu_reportados_vs_entregados";
import "../../styles/graficas.css";

const NfuReportadosVSEntregados = ({ year, token, idPuntoGeneracion }) => {
  const chartRef = useRef(null);
  const data = useNfuData(year, token, idPuntoGeneracion);

  useEffect(() => {
    if (Array.isArray(data) && data.length && chartRef.current) {
    if (data.length && chartRef.current) {
      const chartDom = chartRef.current;
      let myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);

      const updateChart = () => {
        myChart.setOption(getChartOptions(data));
        myChart.resize();
      };
            
       
      updateChart();

      window.addEventListener("resize", updateChart);

      return () => {
        window.removeEventListener("resize", updateChart);
        myChart.dispose();
      };
    }
  }
  }, [data]);

  return <div className="grafica" id="NfuReportadosVSEntregados" ref={chartRef} />;
};

export default NfuReportadosVSEntregados;
